<template>
    <div class="app-content">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
            <div class="content-detached content-right">
                <div class="content-body" style="margin-left:0px">
                    <section id="ecommerce-header">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="ecommerce-header-items">
                                    <div class="result-toggler"  style="width:100% !important;">
                                        <button class="navbar-toggler shop-sidebar-toggler" type="button" data-toggle="collapse">
                                            <span class="navbar-toggler-icon d-block d-lg-none"><i class="feather icon-menu"></i></span>
                                        </button>
                                        <div class="search-results" style="width:100% !important;">
                                          <span>Seleccione un estudiante</span>
                                          <v-select placeholder="Listado de estudiantes" v-model="selectStudent" label="nombre_completos" :options="listaEstudiantes" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-on:input="loadGeneralProduct()"/>
                                          <br>
                                          <span> Clasificación  </span>
                                          <span >
                                            {{ clasififacionSeleccionada.nombre_corto }}
                                          </span>
                                          <br>
                                          <span v-text="resultTotal"></span>
                                          <span> Productos encontrados.</span>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </section>
                    <!-- Ecommerce Content Section Starts -->
                    <!-- background Overlay when sidebar is shown  starts-->
                    <div class="shop-content-overlay"></div>
                    <!-- background Overlay when sidebar is shown  ends-->

                    <!-- Ecommerce Products Starts -->
                    <section id="ecommerce-products" class="grid-view">
                       <div class="card ecommerce-card" v-bind:key="index" v-for="(product,index) in listProducts" >
                            <div class="card-content">
                                <div class="item-img text-center">
                                    <template v-if="product.imageUrl == ''">
                                    <img class="img-fluid img-custom" v-bind:src="require('@/assets/images/no-imagen.jpg')" alt="img-placeholder" >
                                    </template>
                                    <template v-else>
                                    <img class="img-fluid" v-bind:src="$store.state.api+'mapgrafi/ecommerce/searchFile/'+product.imageUrl" alt="img-placeholder" style="width:auto !important; height:218px !important;">
                                    </template>
                                </div>
                                <div class="card-body">
                                    <div class="item-wrapper">
                                        <div class="item-rating" >
                                            <div class="badge badge-primary badge-md"  v-if="((product.aplica_descuento == true || product.aplica_descuento == 'S' || product.aplica_descuento == 'true') &&  statusPreventa )">
                                                <span></span> <i class="feather icon-star" > Aplica descuento   </i>
                                            </div>
                                            <div v-else>
                                                <span></span> 
                                            </div>
                                        </div><br>
                                        <div style="display: flex; gap: 10px;">
                                          <span class="item-price" style="color: red;">* Precio sin IVA.</span>
                                          <div>
                                              <span class="item-price" >$ </span><span class="item-price"  v-text="''+parseFloat(product.price).toFixed(2)"> </span><br>
                                              <!--span v-if="product.aplica_descuento" class="item-price" >Con des $ </span><span v-if="product.aplica_descuento" class="item-price"  v-text="''+parseFloat(product.price_desc).toFixed(2)"> </span-->
                                          </div>
                                        </div>
                                    </div>
                                    <div class="item-name">
                                        <span  v-text="product.name"></span>
                                        <p class="item-company">By <span class="company-name">Google</span></p>
                                    </div>
                                    <div>
                                        <p class="item-description" v-text="(product.description == null ) ? product.description : product.name"></p>
                                        <template v-if="statusPreventa">
                                              <!--template v-if="isInCart(product)">
                                                <vs-input-number  v-bind:min="10" v-bind:value="12" class="inline-flex" />
                                              </template-->
                                               <div class="text-center">
                                                  <span style="font-weight: bold;color: #0d873b;">CON STOCK</span>
                                               </div>
                                        </template>

                                        <template v-else>
                                                <div class="text-center">
                                                  <span v-if="product.disabledAdd" style="font-weight: bold;color: red;">SIN STOCK</span>
                                                  <span v-else style="width: auto;font-weight: bold;color: #0d873b;" v-text="'STOCK: '+(product.stock - 5)"></span>
                                               </div>
                                        </template>
                                        <!--span v-if="!statusStudentSelect" style="width: auto;color: red;">   SELECCIONE UN ESTUDIANTE</span-->
                                    </div>
                                </div>
                                <div class="item-options text-center">
                                    <div class="item-wrapper">
                                        <div class="item-rating">
                                            <div class="badge badge-primary badge-md">
                                                <span>4</span> <i class="feather icon-star"></i>
                                            </div>
                                        </div>
                                        <div class="item-cost">
                                            <h6 class="item-price" v-text="product.price"></h6>
                                        </div>
                                    </div>
                                    <div class="w-full" v-if="$store.state.AppActiveUser.status">
                                      <template v-if="statusPreventa">
                                          <vs-input-number v-show="statusPreventa" 
                                            :disabled="$store.state.AppActiveUser.status && !statusStudentSelect  && !product.disabledAdd"
                                            v-bind:min="parseInt(product.cantidad)" 
                                            v-bind:max="(((product.tipo_producto === tipo_transporte 
                                              && item.cod_producto === 
                                              parseInt(id_transporte)) == true) ? product.stock : 999)"
                                            :value="parseInt(cantidadProducto(product))"
                                            @input="actualizacionProductoShop($event, product)" class="inline-flex" />
                                      </template>
                                            <!-- :value="parseInt(((product.quantity) == null ? 0 : product.quantity))" -->

                                      <template v-else>
                                          <vs-input-number v-bind:min="1" 
                                          :disabled="$store.state.AppActiveUser.status &&  !statusStudentSelect && !product.disabledAdd"
                                          v-bind:max="parseInt(product.stock)" 
                                          :value="parseInt(cantidadProducto(product))"
                                          @input="actualizacionProductoShop($event, product)" 
                                          class="inline-flex" />
                                      </template>
                                          <!-- :value="parseInt(((product.quantity) == null ? 0 : product.quantity))" -->

                                    </div>
                                                    <!-- SECONDARY BUTTON: ADD-TO/VIEW-IN CART -->
                                    <div v-if="statusStudentSelect && !product.disabledAdd"  name="options"
                                        class="item-view-secondary-action-btn bg-primary p-3 flex flex-grow items-center justify-center text-white cursor-pointer"
                                        @click="cartButtonClicked(product)" >
                                        <feather-icon icon="ShoppingBagIcon" svgClasses="h-4 w-4" />
                                        <template v-if="isInCart(product)">
                                          <span class="text-sm font-semibold ml-2" >IR A COMPRAR</span>
                                        </template>
                                        <template  v-else>
                                          <span class="text-sm font-semibold ml-2">AGREGA AL CARRITO</span>
                                        </template>

                                    </div>
                                    <div v-else
                                        class="noStock item-view-secondary-action-btn bg-danger p-3 flex flex-grow items-center justify-center text-white cursor-pointer"
                                        >
                                        <feather-icon icon="ShoppingBagIcon" svgClasses="h-4 w-4" />
                                        <template  v-if="!statusStudentSelect">
                                          <span class="text-sm font-semibold ml-2" >
                                            <template v-if="$store.state.AppActiveUser.status">
                                              SELECCIONE UN ESTUDIANTE
                                            </template> 
                                            <template v-else>
                                              INICIE SESIÓN
                                            </template> 
                                          </span>
                                        </template>
                                        <template  v-else >
                                          <span class="text-sm font-semibold ml-2">PRODUCTO NO DISPONIBLE</span>
                                        </template>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </section>
                    <!-- Ecommerce Products Ends -->

                    <!-- Ecommerce Pagination Starts -->
                    <section id="ecommerce-pagination">
                        <div class="row">
                            <div class="col-sm-12">
                                <nav aria-label="Page navigation example">
                                    <div class="centerx">
                                        <vs-pagination :color="colorx" :total="lengthPagination" v-model="pagination" v-on:click.native="loadGeneralProduct()">
                                        </vs-pagination>
                                    </div>
                                </nav>
                            </div>
                        </div>
                    </section>
                    <!-- Ecommerce Pagination Ends -->
                </div>
          </div>
    </div>
    <vs-popup class="holamundo" title="Mapgrafi informa" :active.sync="popupMensaje">
          <p>{{ mensaje }}
              <br>
          </p>
         <div class="flex flex-wrap justify-center mb-3">
              <vs-button  color="primary"  @click="(popupMensaje = !popupMensaje)">Aceptar</vs-button>
          </div>
      </vs-popup>

    <div class="sidenav-overlay"></div>
    <div class="drag-target"></div>
</div>
  <!-- END: Content-->
</template>

<script>
  export default {
    components: {
      ItemGridView: () => import("./components/ItemGridView.vue"),
      ItemListView: () => import("./components/ItemListView.vue"),
    },
    data() {
      return {
          listaEstudiantes:[],
          statusFirstLoadGeneralComputed : 0,
          mensaje:null,
          popupMensaje:false,
          selectStudent: (localStorage.getItem('student') == null ) ? ({
              nombre_completos:'',
              id_usuario_estudiante : null
          }) : JSON.parse(localStorage.getItem('student')),
          statusPreventa:false,
          listaProductosCompleta:[],
          lengthPagination:0,
          pagination: 1,
          listProducts:[], // productos que se muestran
          colorx: '#0d873b',

      }
    },
    computed: {
      tipo_transporte(){
        var tipo_transporte   =  JSON.parse(localStorage.getItem('tipo_transporte'));
        return tipo_transporte;
      },
      id_transporte(){
        var id_transporte  = JSON.parse(localStorage.getItem('id_transporte'));
        return id_transporte;
      },
      // computada de procesos de store state user
      clasififacionSeleccionada(){
       return  this.$store.getters['eCommerce/obtenerClasificacion']
        // var clasificacion = this.$store.state.eCommerce.clasificacion_seleccionada;
        // return clasificacion;
      },
      activeUserInfo() {
        return this.$store.state.AppActiveUser
      },
      user_stateValue() {
        return this.activeUserInfo.status
      },
      statusStudent(){
        return (this.activeUserInfo.status);
      },
      //computada de estudiantes
      statusStudentSelect(){
        var estudiante  = this.selectStudent;
         if(_.isEmpty(estudiante)){
            this.popupMensaje = true;
            this.mensaje      = 'Seleccione un estudiante';
            return false;
        } else if (estudiante.id_usuario_estudiante == null){
              estudiante =  this.selectStudent[0]
             return false;
        }
        else{
          localStorage.setItem('student', JSON.stringify(estudiante));
          return true;
        }
      },
      //computada de productos
      resultTotal(){
        var listaCompeta  = (_.size(this.listaProductosCompleta) < 1 ) ?  _.size(this.listaProductosCompleta) : ( _.size(this.listaProductosCompleta) * _.size(this.listProducts));
        return listaCompeta;
      },
      isInCart() { // verifica si esta en el carro
        return (itemId) => this.$store.getters['eCommerce/isInCart'](itemId)
      },
      // metodos del ecommerce shop
      windowWidth() {
        return this.$store.state.windowWidth
      },
      //obtener cantidad
      cantidadProducto(producto) { // verifica si esta en el carro
        return (producto) => this.$store.getters['eCommerce/cantidadProducto'](producto)
      },
    },
    watch: {
      windowWidth() {
        this.setSidebarWidth()
      },
    },
    methods: {
      actualizacionProductoShop(event, producto) {
        if  (_.isUndefined(producto.cantidad))  {
            this.$store.dispatch('eCommerce/agregarProductoShop', producto).then(response=>{
                  this.$http.post(this.$store.state.domain+`mapgrafi/mapgrafi-general/inserta-actualiza-elimina-carrito`,{
                      evento    : "GUARDAR",
                      id_usuario: this.activeUserInfo.id_usuario,
                      carrito   : (localStorage.getItem('carItems')),
                      cod_empresa:process.env.VUE_APP_COD_EMPRESA_ERP,
                  })
            })
        }
        else if (event > 0 && producto.quantity <= event) { // suma 
          producto.quantity = producto.quantity + 1;
          producto.cantidad = producto.cantidad + 1;
          this.$store.dispatch("eCommerce/actualizarProductoShop",producto).then(response=>{
                this.$http.post(this.$store.state.domain+`mapgrafi/mapgrafi-general/inserta-actualiza-elimina-carrito`,{
                      evento    : "GUARDAR",
                      id_usuario: this.activeUserInfo.id_usuario,
                      carrito   : (localStorage.getItem('carItems')),
                      cod_empresa:process.env.VUE_APP_COD_EMPRESA_ERP,
                  })
          })
        }
        else if (producto.cantidad -1 >= 0 && producto.quantity > event)  { // resta 
            producto.quantity = producto.quantity - 1;
            producto.cantidad = producto.cantidad - 1;
            this.$store.dispatch("eCommerce/actualizarProductoShop",producto).then(response=>{
                  this.$http.post(this.$store.state.domain+`mapgrafi/mapgrafi-general/inserta-actualiza-elimina-carrito`,{
                      evento    : "GUARDAR",
                      id_usuario: this.activeUserInfo.id_usuario,
                      carrito   : (localStorage.getItem('carItems')),
                      cod_empresa:process.env.VUE_APP_COD_EMPRESA_ERP,
                  })
            })
        }

      },
      // metodos para los estudiantes
      obtenerListado(){
            if(!_.isEmpty(this.selectStudent.nombre_completos) && this.statusPreventa ){
                axios.post(this.$store.state.domain+`mapgrafi/estudiante/lista-completa-carga-general`,{
                  numero_identificacion  : this.selectStudent.numero_identificacion,
                    cod_bodega: null,
                    cod_empresa:process.env.VUE_APP_COD_EMPRESA_ERP,
                      cod_empresa_aca:process.env.VUE_APP_COD_EMPRESA_ACADEMICO
                  })
                  .then((response) => { 
                    if(response.status != 200) throw 'ERROR EN EL SERVIDOR';
                      if((response.data.existeError)) throw response.data.mensaje;
                        if(_.isEmpty(response.data.data)) throw 'No hay data';
                          var _this   = this;
                            localStorage.setItem('listaCompletaEstudiante', JSON.stringify(response.data.data[0]));
                            var listaCompleta = response.data.data[0];
                            if(_.size(listaCompleta)>0){
                              _.forEach(_this.listProducts, (producto) =>{
                                  var mergeProducto = _.find(listaCompleta, (productoListaCompleta) => { return producto.objectID ==  productoListaCompleta.cod_producto; });
                                  if(_.size(mergeProducto)>0){
                                    _.merge(producto,mergeProducto);
                                    producto.description = (_.isEmpty(producto.description) == true ) ? '_' : producto.description;
                                  }
                              });
                            }
                  })
                  .catch((error)=>{
                    this.popupMensaje = true;
                    this.mensaje = 'Debe estar matriculado el estudiante';
                  });
            }
      },
      loadGeneralStudens(){
            return new Promise((resolve, reject) =>{
                  var _this = this;
                  var playLoad = {
                      "id_usuario" : this.$store.state.AppActiveUser.id_usuario,
                      "cod_persona": this.$store.state.AppActiveUser.cod_persona,
                      "estado"     : "A"
                  }
                  this.$store.dispatch('student/loadGeneral', playLoad)
                  .then((response) => {
                    resolve(response);
                  })
                  .catch(error => {
                    reject(error);
                  this.$vs.loading.close()
                  this.mensaje      = error.message;
                  this.popupMensaje = true;
                  });
            })
      },
      loadGeneralStudentCreate(){

                  var _this = this;
                  var playLoad = {
                      "id_usuario" : this.$store.state.AppActiveUser.id_usuario,
                      "cod_persona": this.$store.state.AppActiveUser.cod_persona,
                      "estado"     : "A"
                  }
                  this.$store.dispatch('student/loadGeneral', playLoad)
                  .then((response) => {
                      this.listaEstudiantes =  response.data.data;
                  })
                  .catch(error => {
                  this.$vs.loading.close()
                  this.mensaje      = error.message;
                  this.popupMensaje = true;
                  });
      },
      // metodos de productos
      loadGeneralProduct(){
          this.$vs.loading();
            axios.post(this.$store.state.domain+`mapgrafi/ecommerce/producto`,{
                data:{
                      method            : "producto-carga-general",
                      cod_producto      : null,
                      estado            : "A",
                      tipo              : "M",
                      cod_clasificacion : (this.$route.params.cod_clasificacion == 'null') ? null: this.$route.params.cod_clasificacion,
                      param_busqueda    : (this.$route.params.param_busqueda    == 'null') ? null: this.$route.params.param_busqueda,
                      positionPagination: "9",
                      cod_empresa:process.env.VUE_APP_COD_EMPRESA_ERP
                },
                cod_empresa:process.env.VUE_APP_COD_EMPRESA_ERP
            })
            .then((response) => {
              if(response.status != 200) throw 'ERROR EN EL SERVIDOR';
                else if (response.data.existeError) throw response.data.mensaje;
                  else if (response.data.data != null){
                    this.listaProductosCompleta  = response.data.data;
                    this.lengthPagination = _.size(this.listaProductosCompleta);
                    if(!this.user_stateValue && !this.statusStudentSelect) this.loadProductsShopPaginationNoStudent(); // Proceso de cargar productos sin estudiante 
                    else{
                      this.loadGeneralStudens().then((response)=>{
                        this.loadProductsShopPaginationStudent();
                      }).catch((error)=>{
                        this.loadProductsShopPaginationStudent();
                      });
                    }
                    this.statusFirstLoadGeneralComputed = this.statusFirstLoadGeneralComputed + 1;
                  }
                  this.$vs.loading.close();
            })
            .catch(error=>{
                this.$vs.loading.close();
                this.popupError = true;
              
            });
        },
        loadProductsShopPaginationNoStudent(){
          var _this = this;
          _.forEach(_this.listaProductosCompleta,function(listProductPagination,key){
              if((_this.pagination -1 )== key){
                _this.listProducts = listProductPagination;
                _.forEach(listProductPagination,function(producto){
                    if(producto.stock == null || producto.stock == '' || producto.stock <= 0) producto.disabledAdd =  true;
                    else{
                      producto.disabledAdd  = false;
                    }
                    // producto.price_desc =               localStorage.getItem('discount_post');
                    if((producto.aplica_descuento == true || producto.aplica_descuento == 'S' || producto.aplica_descuento == 'true')){
                      // producto.price_desc  = (producto.price - ( producto.price * JSON.parse(localStorage.getItem('discount_post')) ) / 100 ).toFixed(2); 
                      producto.price_desc  = (producto.price - ( producto.price * JSON.parse(localStorage.getItem('discount_post')) ) / 100 ); 
                      producto.porcentaje_descuento  = JSON.parse(localStorage.getItem('discount_post'));
                      producto.valor_descuento       = producto.price_desc;
                      producto.isProductPreventa            = true;

                    }else{
                      producto.price_desc           = producto.price;
                      producto.porcentaje_descuento = 0;
                      producto.valor_descuento      = 0;
                      producto.isProductPreventa           = false;

                    }
                    // mapeo de informaciòn de estudiante
                });
                _this.$forceUpdate();
                _this.$vs.loading.close();
                return false;
              }
          });
            // this.$vs.loading.close();
        },
        loadProductsShopPaginationStudent(){
          var _this = this;
          _.forEach(_this.listaProductosCompleta,function(listProductPagination,key){
              if((_this.pagination -1 )== key){
                _this.listProducts = listProductPagination;
                _.forEach(listProductPagination,function(producto){
                    if((producto.stock == null || producto.stock == '' || (producto.stock -5) <= 0) && !_this.statusPreventa) producto.disabledAdd =  true;
                    else{
                      producto.disabledAdd  = false;
                    }
                    // producto.price_desc =               localStorage.getItem('discount_post');
                    if((producto.aplica_descuento == true || producto.aplica_descuento == 'S' || producto.aplica_descuento == 'true')){
                      // producto.price_desc  = (producto.price - ( producto.price * JSON.parse(localStorage.getItem('discount_post')) ) / 100 ).toFixed(2); 
                      producto.price_desc  = (producto.price - ( producto.price * JSON.parse(localStorage.getItem('discount_post')) ) / 100 ); 
                      producto.porcentaje_descuento  = JSON.parse(localStorage.getItem('discount_post'));
                      producto.valor_descuento       = producto.price_desc;
                      producto.isProductPreventa            = true;

                    }else{
                      // producto.price_desc           = producto.price;
                      producto.price_desc           = 0;
                      producto.porcentaje_descuento = 0;
                      producto.valor_descuento      = 0;
                      producto.isProductPreventa           = false;

                    }
                    // mapeo de informaciòn de estudiante
                    producto.nombre_completos      = _this.selectStudent.nombre_completos;
                    producto.id_usuario_estudiante = _this.selectStudent.id_usuario_estudiante;
                    producto.id_estudiante         = _this.selectStudent.id_estudiante;
                    producto.cod_matricula         = _this.selectStudent.cod_matricula;
                    producto.cod_persona           = _this.selectStudent.cod_persona;
                    producto.student               = _this.selectStudent;
                });
                _this.$vs.loading.close();
                // return false;
              }
          });
            this.obtenerListado();
          // this.$vs.loading.close();
      },
      additemInCart(item) {
        if(item.student.id_usuario_estudiante == null){
          location.reload();
        }
        else {
          this.$store.dispatch('eCommerce/additemInCart', item)
          this.$http.post(this.$store.state.domain+`mapgrafi/mapgrafi-general/inserta-actualiza-elimina-carrito`,{
                      evento    : "GUARDAR",
                      id_usuario: this.activeUserInfo.id_usuario,
                      carrito   : (localStorage.getItem('carItems')),
                      cod_empresa:process.env.VUE_APP_COD_EMPRESA_ERP,
          })
          .then((response) => {
              this.$vs.loading.close(); 
          })
          .catch(() => {
              this.$vs.loading.close(); 
          });
        }
      },
      cartButtonClicked(item) {
        this.isInCart(item) ? this.$router.push('/list/checkout-products').catch(() => {}) : this
          .additemInCart(item)
      },
      // metodos del ecommerce shop
      
      setSidebarWidth() {
        if (this.windowWidth < 992) {
          this.isFilterSidebarActive = this.clickNotClose = false
        } else
          this.isFilterSidebarActive = this.clickNotClose = true
      },
      validaFechaPreventa(){
        var  fecha_preventa =   JSON.parse(localStorage.getItem('date_pre_sale'));
        var _this   = this;
        let obtenerFechaActual = new Promise((resolve, reject) => {
            axios.get(this.$store.state.domain+`mapgrafi/mapgrafi-general/obtener-fecha`)
            .then((response) => {
              resolve(response);
            })
        });
        obtenerFechaActual.then((response) => {
          _this.statusPreventa  = moment(response.data).isBetween(fecha_preventa.fechaDesde, fecha_preventa.fechaHasta, null, '[]'); //truereturn true
          _this.loadGeneralProduct();
          localStorage.removeItem('statusPreventa');
          localStorage.setItem('statusPreventa',JSON.stringify(_this.statusPreventa));
        });
      },
    },
    created() {
      this.$root.EcommerceShop = this;
      this.validaFechaPreventa();
      if(this.user_stateValue)this.loadGeneralStudentCreate();
    }
  }

</script>

<style scoped>
.img-custom{
  width:160px !important;
  height:180px !important;  
}
.noStock{
      background: #d4d4d4 !important;
      color: #666 !important;
      cursor: default !important;

}
</style>